
    import Vue from 'vue';

    export default Vue.extend({
        name: "PageNotFound",
        data: () => ({
            mounted: false
        }),
        mounted() {
            this.mounted = true
        }
    })
